import { useContext, useLayoutEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { AuthCookieContext } from 'utils/context';
import { templatesRegistry } from 'utils/templates';
import { useNavigateWithQuery } from 'utils/useNavigateWithQuery';
import NavigateWithQuery from './NavigateWithQuery';
import NotFound from 'pages/NotFound';

export const TemplateWrapper = () => {
  const { userInfo, setUserInfo, templateConfig } =
    useContext(AuthCookieContext);
  const { templateId: templateIdParams } = useParams();
  const location = useLocation();
  const navigate = useNavigateWithQuery();

  useLayoutEffect(() => {
    const templateId =
      templatesRegistry.getConfig(templateIdParams)?.templateId;

    if (!templateId) {
      return;
    }

    if (templateIdParams && templateId !== templateIdParams) {
      const path = location.pathname.replace(templateIdParams, templateId);
      navigate(path, { replace: true });
    }

    if (userInfo?.templateId !== templateId) {
      setUserInfo((prev) => ({
        ...prev,
        templateId,
      }));
    }
  }, [
    location.pathname,
    navigate,
    setUserInfo,
    templateIdParams,
    userInfo?.templateId,
  ]);

  if (!templatesRegistry.getConfig(templateIdParams)?.templateId) {
    return <NotFound />;
  }

  if (templateConfig?.getTemplateIdForABTest) {
    const path = location.pathname.replace(
      templateIdParams,
      templateConfig.getTemplateIdForABTest()
    );
    return <NavigateWithQuery to={path} replace />;
  }

  return <Outlet />;
};
